import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

const AuthContext = createContext(null);

// Shared logins are entered as a plain username (case-insensitive), not an
// email address — mapped here to the real account email Supabase Auth uses.
const USERNAME_EMAIL_MAP = {
  admin:     'sales@hobbycity.nz',
  superuser: 'admin@hobbycity.nz',
};

const EMAIL_USERNAME_MAP = Object.fromEntries(
  Object.entries(USERNAME_EMAIL_MAP).map(([username, email]) => [email, username])
);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
    });

    return () => listener.subscription.unsubscribe();
  }, []);

  const signIn = async (username, password) => {
    const email = USERNAME_EMAIL_MAP[username.trim().toLowerCase()];
    if (!email) {
      return { error: { message: 'Invalid username or password' } };
    }
    return supabase.auth.signInWithPassword({ email, password });
  };

  const signOut = () => supabase.auth.signOut();

  const role = session?.user?.app_metadata?.role || null;
  const username = EMAIL_USERNAME_MAP[session?.user?.email] || session?.user?.email || null;

  return (
    <AuthContext.Provider value={{ session, loading, role, username, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
